import type { IJsonModel } from 'flexlayout-react';

/**
 * Layout used when the Prefab Layer Tree dev panel is open.
 * Bottom row splits: article preview (left) + layer tree (right).
 */
export const settingOptionsWithTreeModelJson: IJsonModel = {
    global: {
        tabEnableClose: false,
        tabSetEnableSingleTabStretch: true,
        tabSetEnableMaximize: false,
        tabSetEnableDrop: false,
        tabEnableDrag: false,
        tabEnableRename: false,
        tabClassName: 'cursor-default',
    },
    layout: {
        weight: 100,
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        weight: 65,
                        children: [
                            {
                                type: 'tab',
                                name: '',
                                component: 'settingOptions',
                            },
                        ],
                    },
                    {
                        type: 'row',
                        weight: 35,
                        children: [
                            {
                                type: 'tabset',
                                weight: 58,
                                children: [
                                    {
                                        type: 'tab',
                                        name: '',
                                        component: 'articlePreview',
                                    },
                                ],
                            },
                            {
                                type: 'tabset',
                                weight: 42,
                                children: [
                                    {
                                        type: 'tab',
                                        name: '',
                                        component: 'prefabLayerTree',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
